import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_STAFF]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_STAFF]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/recommended_staff/:roleId/',
	},
}
